import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckinBaseComponent } from '@common/components/checkin-base-class';
import { AppConstants } from '@conf/app.constants';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-checkin-search-sub-header',
  templateUrl: './checkin-search-sub-header.component.html',
  styleUrls: ['./checkin-search-sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckinSearchSubHeaderComponent extends CheckinBaseComponent {
  /** ページタイトル */
  pageTitle?: string;

  appConstants = AppConstants

  constructor(commonService: CommonLibService) {
    super(commonService);
  }

  override reload(): void {}
  override init(): void {}
  override destroy(): void {}
}
